<template>
  <a-card :bordered="false">
    <!-- 操作 -->
    <div class="table-operations">
      <a-button type="primary" @click="$refs.createForm.handleAdd(type, queryParam.language)">
        <a-icon type="plus" />新增
      </a-button>

      <a-button type="primary" @click="openImportDrawer">
        <a-icon type="plus" />导入已有片单
      </a-button>
    </div>

    <div class="table-operations">
      <a-button :type="activeLanguage === 'zh' ? 'primary' : 'default'" @click="getList('zh')">
        中文
      </a-button>
      <a-button :type="activeLanguage === 'en' ? 'primary' : 'default'" @click="getList('en')">
        英文
      </a-button>
      <a-button :type="activeLanguage === 'ja' ? 'primary' : 'default'" @click="getList('ja')">
        日文
      </a-button>

      <a-button :type="activeLanguage === 'id' ? 'primary' : 'default'" @click="getList('id')">
        印尼
      </a-button>
      <a-button :type="activeLanguage === 'pt' ? 'primary' : 'default'" @click="getList('pt')">
        葡语
      </a-button>
      <a-button :type="activeLanguage === 'es' ? 'primary' : 'default'" @click="getList('es')">
        西语
      </a-button>
    </div>
    <create-form ref="createForm" @ok="getList" />

    <!-- 数据展示 -->
    <a-table :loading="loading" rowKey="id" :columns="columns" :data-source="list"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :pagination="false"
      :bordered="tableBordered" @rowClick="handleRowClick">
      <span slot="isOpen" slot-scope="text, list" @click.stop>
        <a-switch checkedChildren="是" unCheckedChildren="否" :checked="list.isOpen == 1"
          @change="changePlaylistIsOpen($event, list)" />
      </span>
      <span slot="operation" slot-scope="text, list" @click.stop>
        <a @click="$refs.createForm.handleUpdate(list)">
          <a-icon type="edit" />修改
        </a>
        <a-divider type="vertical" @click.stop />
        <a @click="handleDelete(list)">
          <a-icon type="delete" />删除
        </a>
      </span>
    </a-table>
    <!-- 右侧抽屉 -->
    <a-drawer placement="right" :visible="drawerVisible" :width="'80%'" :maskClosable="false" :keyboard="false"
      @close="closeDrawer" :title="drawerMode === 'detail' ? '片单列表详情' : '导入已有片单'">
      <playlist-video-details v-if="drawerMode === 'detail' && currentRow" :playlistId="currentRow.id"
        :key="currentRow.id" @close="closeDrawer" />
      <import-playlist v-if="drawerMode === 'import'" :existingVideoIds="list.map(item => item.id)" :type="type"
        :language="queryParam.language" @close="closeDrawer" />
    </a-drawer>
  </a-card>
</template>
  
<script>
import {
  delCustomizeForm,
  selectCustomizeForm,
  changePlaylistIsOpen
} from '@/api/video/video'
import CreateForm from './CreateForm'
import ImportPlaylist from './ImportPlaylist'
import PlaylistVideoDetails from './PlaylistVideoDetails'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Details',
  props: {
    type: {
      type: Number,
      required: true
    },
  },
  components: {
    CreateForm,
    PlaylistVideoDetails,
    ImportPlaylist
  },
  mixins: [tableMixin],
  data() {
    return {
      activeLanguage: 'zh',
      drawerMode: '',
      drawerVisible: false,
      currentRow: null,
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      queryParam: {
        type: this.type,
        language: 'zh',
      },
      columns: [
        {
          title: '片单名称',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '短剧数量',
          dataIndex: 'count',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '是否启用',
          dataIndex: 'isOpen',
          align: 'center',
          scopedSlots: { customRender: 'isOpen' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created() {
    this.getList(this.activeLanguage)
  },
  computed: {
  },
  watch: {
    type(newType) {
      this.queryParam.type = newType
      this.getList(this.activeLanguage)
    }
  },
  methods: {

    getList(data) {
      this.loading = true
      if (data == null) {
        data = this.activeLanguage;
      }
      this.queryParam.language = data;
      this.activeLanguage = data;
      selectCustomizeForm(this.queryParam).then(response => {
        console.log(response)
        this.list = response.data
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.getList(this.activeLanguage)
    },
    changePlaylistIsOpen(e, list) {
      list.isOpen = e ? 1 : 0
      changePlaylistIsOpen({ id: list.id, isOpen: list.isOpen }).then(response => {
        this.$message.success(
          '操作成功'
        )
        this.getList(this.activeLanguage)
        return list.isOpen = e ? 1 : 0
      })
    },
    handleRowClick(list) {
      this.currentRow = list // 保存当前选中的行数据
      this.drawerMode = 'detail'
      this.drawerVisible = true
    },
    openImportDrawer() {
      this.drawerMode = 'import'
      this.drawerVisible = true
      console.log("父组件的 type:", this.type); // 检查是否有值
      console.log("父组件的 language:", this.queryParam.language);
    },
    closeDrawer() {
      this.drawerVisible = false
      this.currentRow = null
      this.drawerMode = ''
      this.getList(this.activeLanguage) // 保留原语言
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delCustomizeForm(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
  }
}
</script>
  